import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const POSITION = [45.3989, 8.916];

export default function Map() {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;
    const map = L.map(ref.current, { scrollWheelZoom: false, attributionControl: true }).setView(POSITION, 14);
    L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
      maxZoom: 19,
    }).addTo(map);
    const icon = L.divIcon({
      className: "",
      html: '<div style="width:18px;height:18px;border-radius:50%;background:#D97736;border:3px solid #0B0C0E;box-shadow:0 0 0 6px rgba(217,119,54,0.3),0 0 24px rgba(217,119,54,0.6)"></div>',
      iconSize: [18, 18],
      iconAnchor: [9, 9],
    });
    L.marker(POSITION, { icon })
      .addTo(map)
      .bindPopup("<strong>MERLO coperture</strong><br>Via E. Zacconi 11, Abbiategrasso (MI)");
    return () => map.remove();
  }, []);

  return (
    <div
      ref={ref}
      data-testid="sede-map"
      className="h-72 sm:h-80 w-full rounded-3xl border border-white/10 overflow-hidden"
      style={{ isolation: "isolate" }}
      aria-label="Mappa della sede: Via E. Zacconi 11, Abbiategrasso (MI)"
    />
  );
}
